module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/holding-phone-mockup-9b619efbed1865e224e198d321da4120.png";